import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalPoolsDetails extends Component{
	constructor(props){
		super(props);
		
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:false,
			parts:[],
			pools_process:{}
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'pools_process/'+id,{
			methid:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show:true,
					parts:response.parts,
					pools_process:response.pools_process
				});
			}
		});
	}

	handleClose(){
		this.setState({
			show:false
		});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles Pools</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        	<div className="col-xs-12">
	        				<Table responsive hover>
	        					<thead>
		        					<tr>
		        						<th>No. Unidad</th>
		        						<th>Componente</th>
		        						<th>No. Componente</th>
		        						<th>Caducidad</th>
		        						<th>Volumen</th>
		        						<th>Grupo & RH</th>
		        					</tr>
	        					</thead>
	        					<tbody>
	        						{this.state.parts.map((part, i)=>(
	        							<tr key={i}>
	        								<td>{part.unit.unit_number}</td>
		        							<td>{part.component}</td>
	        								<td>{part.unit.component_number}</td>
	        								<td>{moment(part.unit.caducidad).format('DD/MM/YYYY')}</td>
	        								<td>{part.unit.volume}</td>
	        								<td>
	        									{part.unit.group+(
	        										part.unit.rh === 'POSITIVO' ? '+' :
	        										part.unit.rh === 'NEGATIVO' ? '-' : ''
	        									)}
	        								</td>
	        							</tr>
	        						))}
	        					</tbody>
	        				</Table>
	        			</div>
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="text" className="form-control"
		        					value={moment(this.state.pools_process.date).format('DD/MM/YYYY') || ""} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Hora</span>
		        				<input type="text" className="form-control"
		        					value={moment(this.state.pools_process.hour).format('HH:mm') || ""} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Grupo Sanguíneo</span>
		        				<input type="text" className="form-control"
		        					value={(this.state.pools_process.group+(
		        						this.state.pools_process.rh === 'POSITIVO' ? '+' :
		        						this.state.pools_process.rh === 'NEGATIVO' ? '-' : ''
		        					)) || ""} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Volumen (ml)</span>
		        				<input type="text" className="form-control"
		        					value={this.state.pools_process.total_volume || ""} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Bolsa Lote</span>
		        				<input type="text" className="form-control"
		        					value={this.state.pools_process.bag_lot || ""} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Solucioón Aditiva</span>
		        				<input type="text" className="form-control"
		        					value={this.state.pools_process.aditive_solution || ""} disabled />
		        			</div>
		        		</div>
		        		
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}

}
export default translate('translations')(ModalPoolsDetails)